import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import Helmet from "@/components/base/Helmet";

const teamMembers = [
  {
    name: "陈志远",
    role: "创始人 & CEO",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20business%20casual%20attire%2C%20friendly%20expression%2C%20studio%20photography%20on%20dark%20background%2C%20clean%20and%20modern%20headshot&width=200&height=200&seq=douhua-team-1&orientation=squarish",
  },
  {
    name: "林晓薇",
    role: "内容总监",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Chinese%20woman%20portrait%20with%20warm%20lighting%2C%20modern%20business%20attire%2C%20confident%20smile%2C%20studio%20photography%20on%20dark%20background%2C%20clean%20headshot&width=200&height=200&seq=douhua-team-2&orientation=squarish",
  },
  {
    name: "王浩然",
    role: "技术负责人",
    avatar: "https://readdy.ai/api/search-image?query=young%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20casual%20professional%20style%2C%20friendly%20expression%2C%20studio%20photography%20on%20dark%20background%2C%20modern%20headshot&width=200&height=200&seq=douhua-team-3&orientation=squarish",
  },
  {
    name: "张雨桐",
    role: "运营主管",
    avatar: "https://readdy.ai/api/search-image?query=professional%20Chinese%20woman%20portrait%20with%20warm%20lighting%2C%20smart%20casual%20attire%2C%20friendly%20smile%2C%20studio%20photography%20on%20dark%20background%2C%20modern%20headshot&width=200&height=200&seq=douhua-team-4&orientation=squarish",
  },
];

const testimonials = [
  {
    name: "小明",
    text: "豆花视频真的超好用！画质清晰，更新也快，追剧必备。91视频和97视频资源很全，再也不用到处找了。",
    rating: 5,
  },
  {
    name: "影视爱好者阿杰",
    text: "作为资深影迷，我用过很多视频平台，豆花视频的高清不缓冲体验确实好。51视频的纪录片资源也很丰富。",
    rating: 5,
  },
  {
    name: "小陈同学",
    text: "免费在线观看太香了！电视剧全集更新及时，分类清晰，找片很方便。推荐给身边好多朋友了。",
    rating: 5,
  },
  {
    name: "晚风",
    text: "页面简洁好看，没有乱七八糟的广告，观影体验非常棒。动漫和综艺资源也多，每天都要刷一刷。",
    rating: 4,
  },
];

const milestones = [
  { year: "2022", title: "豆花视频正式上线", desc: "团队初创，致力于打造优质的数字视频平台，为用户提供91视频、97视频等免费在线观看服务" },
  { year: "2023", title: "内容库突破万部", desc: "平台内容快速增长，涵盖电视剧、电影、综艺、动漫、纪录片等多个品类，用户量突破百万" },
  { year: "2024", title: "技术全面升级", desc: "全新高清播放引擎上线，实现真正的高清不缓冲观看体验，51视频等特色频道正式推出" },
  { year: "2024", title: "迈向新征程", desc: "持续优化产品体验，拓展内容合作，致力成为领先的数字视频平台" },
];

export default function AboutPage() {
  const seoData = {
    title: "关于我们 - 豆花视频 | 品牌介绍与联系方式",
    description:
      "豆花视频致力于为数字视频平台爱好者提供91视频、97视频、51视频免费在线观看服务。了解豆花视频的品牌故事、团队介绍、用户口碑和联系方式。",
    keywords: "豆花视频,关于我们,品牌介绍,联系方式,用户口碑,91视频,97视频,51视频",
    canonical: "https://douhuavideo.com/about",
  };

  const graphLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        name: "关于豆花视频",
        description: seoData.description,
        url: seoData.canonical,
        isPartOf: {
          "@type": "WebSite",
          name: "豆花视频",
          url: "https://douhuavideo.com",
        },
      },
      {
        "@type": "Organization",
        name: "豆花视频",
        url: "https://douhuavideo.com",
        description: seoData.description,
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+86-400-123-4567",
          contactType: "customer service",
          email: "contact@douhuavideo.com",
          availableLanguage: ["Chinese"],
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "豆花视频是否真的免费？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "是的，豆花视频平台上的91视频、97视频、51视频等所有内容均免费在线观看，无需付费订阅。",
            },
          },
          {
            "@type": "Question",
            name: "豆花视频支持哪些设备观看？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "豆花视频支持电脑、平板、手机等多种设备在线观看，只需浏览器即可享受高清视频体验。",
            },
          },
          {
            "@type": "Question",
            name: "视频更新频率如何？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "我们每日更新最新电视剧、电影和综艺内容，确保用户第一时间看到最热门的视频资源。",
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <Helmet
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        canonical={seoData.canonical}
        ogTitle={seoData.title}
        ogDescription={seoData.description}
        ogType="website"
        scriptLd={{ ...graphLd }}
      />

      <div className="min-h-screen bg-gray-950">
        <Navbar />

        <main className="pt-20 pb-8">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-5xl mx-auto">
              <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "关于我们" }]} />

              {/* Hero */}
              <section className="text-center py-10 md:py-16">
                <div className="w-20 h-20 mx-auto flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl mb-6">
                  <i className="ri-play-fill text-white text-3xl"></i>
                </div>
                <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">关于豆花视频</h1>
                <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
                  豆花视频是一个专注于数字视频内容聚合的平台，致力于为全国用户提供
                  91视频、97视频、51视频等精品内容免费在线观看服务，
                  以高清不缓冲的播放体验和丰富的片库，成为您最信赖的在线视频伙伴。
                </p>
              </section>

              {/* Milestones */}
              <section className="mb-12 md:mb-16">
                <h2 className="text-lg md:text-xl font-bold text-white text-center mb-8">
                  发展历程
                </h2>
                <div className="relative">
                  <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gray-800 md:-translate-x-px"></div>
                  <div className="flex flex-col gap-8">
                    {milestones.map((m, i) => (
                      <div
                        key={i}
                        className={`relative pl-12 md:pl-0 md:w-1/2 ${
                          i % 2 === 0 ? "md:pr-12 md:ml-0" : "md:pl-12 md:ml-auto"
                        }`}
                      >
                        <div className="absolute left-0 md:left-auto top-1 w-9 h-9 flex items-center justify-center rounded-full bg-amber-500 text-black font-bold text-xs z-10 md:translate-x-[-50%]"
                          style={i % 2 === 0 ? {} : { right: "auto", left: "auto" }}
                        >
                          {m.year}
                        </div>
                        <div className="bg-gray-900/70 border border-gray-800/50 rounded-xl p-4 md:p-5">
                          <h3 className="text-sm font-bold text-white mb-1.5">{m.title}</h3>
                          <p className="text-xs text-gray-400 leading-relaxed">{m.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>

              {/* Team */}
              <section className="mb-12 md:mb-16">
                <h2 className="text-lg md:text-xl font-bold text-white text-center mb-2">
                  核心团队
                </h2>
                <p className="text-xs md:text-sm text-gray-400 text-center mb-8">
                  一群热爱视频内容的伙伴
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
                  {teamMembers.map((member, i) => (
                    <div key={i} className="text-center">
                      <div className="w-20 h-20 md:w-24 md:h-24 mx-auto rounded-2xl overflow-hidden mb-3 bg-gray-800">
                        <img
                          src={member.avatar}
                          alt={member.name}
                          className="w-full h-full object-cover"
                          width={200}
                          height={200}
                        />
                      </div>
                      <h3 className="text-sm font-bold text-white">{member.name}</h3>
                      <p className="text-xs text-gray-400 mt-0.5">{member.role}</p>
                    </div>
                  ))}
                </div>
              </section>

              {/* Testimonials */}
              <section className="mb-12 md:mb-16">
                <h2 className="text-lg md:text-xl font-bold text-white text-center mb-2">
                  用户口碑
                </h2>
                <p className="text-xs md:text-sm text-gray-400 text-center mb-8">
                  来自真实用户的评价
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {testimonials.map((t, i) => (
                    <div
                      key={i}
                      className="bg-gray-900/70 border border-gray-800/50 rounded-xl p-5"
                    >
                      <div className="flex items-center gap-0.5 mb-3">
                        {Array.from({ length: 5 }).map((_, j) => (
                          <i
                            key={j}
                            className={`text-xs ${
                              j < t.rating ? "ri-star-fill text-amber-400" : "ri-star-fill text-gray-700"
                            }`}
                          ></i>
                        ))}
                      </div>
                      <p className="text-sm text-gray-300 leading-relaxed mb-3">{t.text}</p>
                      <p className="text-xs text-gray-500">— {t.name}</p>
                    </div>
                  ))}
                </div>
              </section>

              {/* Contact */}
              <section className="mb-8">
                <h2 className="text-lg md:text-xl font-bold text-white text-center mb-2">
                  联系我们
                </h2>
                <p className="text-xs md:text-sm text-gray-400 text-center mb-8">
                  有任何问题或建议，欢迎与我们取得联系
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="bg-gray-900/70 border border-gray-800/50 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 mb-3">
                      <i className="ri-mail-line text-xl"></i>
                    </div>
                    <h3 className="text-sm font-bold text-white mb-1">电子邮箱</h3>
                    <p className="text-xs text-gray-400">contact@douhuavideo.com</p>
                  </div>
                  <div className="bg-gray-900/70 border border-gray-800/50 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 mb-3">
                      <i className="ri-phone-line text-xl"></i>
                    </div>
                    <h3 className="text-sm font-bold text-white mb-1">客服热线</h3>
                    <p className="text-xs text-gray-400">400-123-4567</p>
                  </div>
                  <div className="bg-gray-900/70 border border-gray-800/50 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 mb-3">
                      <i className="ri-map-pin-line text-xl"></i>
                    </div>
                    <h3 className="text-sm font-bold text-white mb-1">公司地址</h3>
                    <p className="text-xs text-gray-400">北京市朝阳区建国路88号</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}